import { Typography, Box, TextField, Button, Link, Alert } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../Auth.module.scss';

import { validateEmail } from '../helpers';
import apiReq from 'core/api';
import { safeParseApiError } from 'utils/parseApiError';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const navigate = useNavigate();

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    if (error) setError('');
  };

  const validateEmailField = () => {
    if (!email) {
      setError('Email обязателен');
      return false;
    }
    if (!validateEmail(email)) {
      setError('Введите корректный email');
      return false;
    }
    return true;
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (validateEmailField()) {
      try {
        setError('');
        const response = await apiReq<{ status: string }>(`auth/password/reset-request`, 'POST', {
          email,
        });
        if (response && response.status) {
          setIsSubmitted(true);
        } else {
          setError('Ошибка при отправке инструкции по восстановлению пароля');
        }
      } catch (error) {
        const { generalMessage } = safeParseApiError(error);
        setError(generalMessage || 'Ошибка при отправке инструкции по восстановлению пароля');
      }
    }
  };

  const handleBackToLogin = () => {
    navigate('/login');
  };

  if (isSubmitted) {
    return (
      <Box className={styles['auth-container']}>
        <Box className={styles['auth-card']}>
          <Box className={styles['auth-brand']}>
            <img
              className={styles['auth-brand-mark']}
              src={`${process.env.PUBLIC_URL}/logo.svg`}
              alt="Контекст"
              width={26}
              height={26}
            />
            <Box className={styles['auth-brand-name']}>Контекст</Box>
          </Box>
          <Typography className={styles['auth-title']}>Письмо отправлено</Typography>
          <Typography className={styles['auth-subtitle']}>
            Проверьте почту — инструкция по восстановлению пароля внутри.
          </Typography>

          <Alert severity="success" className={styles['auth-message']}>
            Инструкция по восстановлению пароля направлена на {email}
          </Alert>

          <Link
            component="button"
            variant="body2"
            onClick={handleBackToLogin}
            className={styles['auth-link']}
          >
            Вернуться к входу
          </Link>
        </Box>
      </Box>
    );
  }

  return (
    <Box className={styles['auth-container']}>
      <Box className={styles['auth-card']}>
        <Box className={styles['auth-brand']}>
          <img
            className={styles['auth-brand-mark']}
            src={`${process.env.PUBLIC_URL}/logo.svg`}
            alt="Контекст"
            width={26}
            height={26}
          />
          <Box className={styles['auth-brand-name']}>Контекст</Box>
        </Box>
        <Typography className={styles['auth-title']}>Восстановление пароля</Typography>
        <Typography className={styles['auth-subtitle']}>
          Введите email — мы отправим ссылку для сброса пароля.
        </Typography>

        <Box component="form" onSubmit={handleSubmit} className={styles['auth-form']}>
          <TextField
            name="email"
            label="Email"
            type="email"
            size="small"
            value={email}
            onChange={handleEmailChange}
            error={!!error}
            helperText={error}
            fullWidth
            className={styles['auth-input']}
            variant="outlined"
          />

          <Button type="submit" variant="contained" fullWidth className={styles['auth-button']}>
            Отправить
          </Button>
        </Box>

        <Link
          component="button"
          variant="body2"
          onClick={handleBackToLogin}
          className={styles['auth-link']}
        >
          Вернуться к входу
        </Link>
      </Box>
    </Box>
  );
};

export default ForgotPassword;
